export default __webpack_public_path__ + "static/media/redbull.87641419.svg";